//import Module
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
import { NgxQRCodeModule } from 'ngx-qrcode2';

//import Component
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { SideBarComponent } from './layout/side-bar/side-bar.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { PrintQrcodeComponent } from './print-qrcode/print-qrcode.component';
import { UsersComponent } from './users/users.component';
import { DeviceComponent } from './device/device.component';
import { BoardComponent } from './board/board.component';
import { DeviceBoardComponent } from './device-board/device-board.component';
import { HistoryComponent } from './history/history.component';
import { VersionComponent } from './version/version.component';
import { LayoutPrintComponent } from './layout-print/layout-print.component';
import { LayoutPrintFormComponent } from './layout-print-form/layout-print-form.component';
import { AuthguardGuard } from "./authguard.guard";
import { AdminRoleGuard } from "./admin-role.guard";
import { AppService } from "./app.service";
import { PrintQrcodeSmallComponent } from "./print-qrcode-small/print-qrcode-small.component";

const routesConfig: Routes = [
    { path: 'login', component: LoginComponent, pathMatch: 'full' },
    { path: 'print-qrcode/:id', component: PrintQrcodeComponent },
    { path: 'print-qrcode-small/:id', component: PrintQrcodeSmallComponent },
    {
        path: '', canActivate: [AuthguardGuard], component: LayoutComponent,
        children: [
            { path: '', component: DashboardComponent },
            { path: 'qrcode', component: QrCodeComponent },
            { path: 'users',  canActivate: [AdminRoleGuard], component: UsersComponent },
            { path: 'device', canActivate: [AdminRoleGuard], component: DeviceComponent },
            { path: 'board', canActivate: [AdminRoleGuard],  component: BoardComponent },
            { path: 'device-board', canActivate: [AdminRoleGuard], component: DeviceBoardComponent },
            { path: 'history', canActivate: [AdminRoleGuard], component: HistoryComponent },
            { path: 'app-information', canActivate: [AdminRoleGuard], component: VersionComponent },
            { path: 'layout-print', children: [
                {path: '', component: LayoutPrintComponent},
                {path: ':id', component: LayoutPrintFormComponent}
            ]},

            { path: '**', component: DashboardComponent }
        ]
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        NgxQRCodeModule,
        RouterModule.forRoot(
            routesConfig,
            { useHash: true }
        ),
    ],
    declarations: [
        LoginComponent,
        DashboardComponent,
        LayoutComponent,
        HeaderComponent,
        SideBarComponent,
        QrCodeComponent,
        PrintQrcodeComponent,
        UsersComponent,
        DeviceComponent,
        BoardComponent,
        HistoryComponent,
        DeviceBoardComponent,
        VersionComponent,
        LayoutPrintComponent,
        LayoutPrintFormComponent,
        PrintQrcodeSmallComponent
    ],
    providers: [
        AppService,
        AuthguardGuard,
        AdminRoleGuard
    ],
    exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /build/client-cms/src/app/app-routing.module.ts